import Box, { BoxProps } from '@mui/material/Box';

export const createMarkup = (__html: string) => {
  return { __html };
};

export function DisplayMarkupBox(props: {
  markup: string | null;
  sx?: BoxProps['sx'];
}) {
  if (props.markup) {
    return (
      <Box sx={props.sx} dangerouslySetInnerHTML={createMarkup(props.markup)} />
    );
  } else {
    return null;
  }
}

export function DisplayMarkup(props: {
  markup: string | null;
  className?: string;
}) {
  if (props.markup) {
    return (
      <div
        className={props.className}
        dangerouslySetInnerHTML={createMarkup(props.markup)}
      />
    );
  } else {
    return null;
  }
}
